import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { googleLogin, logout } from "../services/authService";
import { useApp } from '../context/AppContext';

const Navbar = () => {
  const location = useLocation();
  const { completedChallenges, user, setUser, isLoadingProgress } = useApp();

  const navItems = [
    { path: '/', name: 'Home', icon: '🏠' },
    { path: '/tutorial', name: 'Tutorial', icon: '📚' },
    { path: '/challenges', name: 'Challenges', icon: '🏆' },
    { path: '/playground', name: 'Playground', icon: '🎨' },
    { path: '/about', name: 'About', icon: 'ℹ️' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo and Brand */}
          <Link to="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
              <span className="text-xl font-bold">C</span>
            </div>
            <div>
              <h1 className="text-xl font-bold">CADPlay</h1>
              <p className="text-xs opacity-75">Learn, Design, Assist</p>
            </div>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 ${
                  isActive(item.path)
                    ? 'bg-white bg-opacity-20 text-white'
                    : 'hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <span>{item.icon}</span>
                <span>{item.name}</span>
                {item.name === 'Challenges' && completedChallenges.length > 0 && (
                  <span 
                    key={completedChallenges.length}
                    className="bg-green-500 text-white text-xs px-2 py-1 rounded-full animate-bounce shadow-lg"
                  >
                    {isLoadingProgress ? '...' : completedChallenges.length}
                  </span>
                )}
              </Link>
            ))}
          </div>

          {/* User Section */}
         <div className="flex items-center space-x-4">
  {user ? (
    <>
      <div className="flex items-center space-x-2">
        {user.photoURL && (
          <img 
            src={user.photoURL} 
            alt="Profile" 
            className="w-8 h-8 rounded-full border-2 border-white"
          />
        )}
        <span className="text-sm font-medium">{user.displayName}</span>
      </div>
      <div className="flex items-center space-x-2">
        <div className="relative">
          <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full font-medium">
            {isLoadingProgress ? '...' : completedChallenges.length}
          </span>
        </div>
        <button
          onClick={async () => {
            await logout();
            setUser(null);
          }}
          className="bg-red-500 px-3 py-1 rounded text-sm hover:bg-red-600 transition-colors"
        >
          Logout
        </button>
      </div>
    </>
  ) : (
    <button
      onClick={async () => {
        try {
          const u = await googleLogin();
          setUser(u);
        } catch (error) {
          console.error('Sign-in failed:', error);
          alert('Sign-in failed. Please try again or check your popup blocker.');
        }
      }}
      className="bg-white text-blue-600 px-4 py-1 rounded text-sm font-medium"
    >
      Sign in with Google
    </button>
  )}
</div>


          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button className="p-2 hover:bg-white hover:bg-opacity-10 rounded-lg">
              <span className="text-lg">☰</span>
            </button>
          </div>
        </div>

        {/* Mobile Navigation (Hidden by default) */}
        <div className="md:hidden border-t border-white border-opacity-20 py-4">
          <div className="space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`block px-4 py-2 rounded-lg transition-colors ${
                  isActive(item.path)
                    ? 'bg-white bg-opacity-20'
                    : 'hover:bg-white hover:bg-opacity-10'
                }`}
              >
                <span className="mr-2">{item.icon}</span>
                {item.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Debug Info */}
        <div className="text-xs text-white opacity-70">
          {user ? `Logged in as ${user.email}` : "Not logged in"}
          <br />
          Completed: {completedChallenges.join(", ") || "None"}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
